module.exports = __webpack_public_path__ + "img/zoom-reset-icon.2cabd7dd.svg";